(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || root.classList.contains('promo-motion-enabled')) {
    return;
  }

  root.classList.add('promo-motion-enabled');

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  ready(function () {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.promo-section'));
    var animatedItems = Array.prototype.slice.call(
      document.querySelectorAll('.promo-split-card, .promo-ritual-card, .promo-offer-card')
    );

    animatedItems.forEach(function (item, index) {
      item.style.setProperty('--promo-stagger-delay', Math.min(index % 6, 5) * 90 + 'ms');
    });

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('promo-in-view');
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    var itemObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('promo-item-in-view');
            itemObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }
    );

    sections.forEach(function (section) {
      sectionObserver.observe(section);
    });

    animatedItems.forEach(function (item) {
      itemObserver.observe(item);
    });

    var ticking = false;

    function updateParallax() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewportCenter = viewportHeight / 2;

      sections.forEach(function (section) {
        var rect = section.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > viewportHeight) {
          return;
        }

        var sectionCenter = rect.top + rect.height / 2;
        var progress = (viewportCenter - sectionCenter) / viewportHeight;
        var y = clamp(progress * 22, -14, 14);

        section.style.setProperty('--promo-parallax-y', y.toFixed(2) + 'px');
        section.style.setProperty('--promo-image-parallax-y', (-y * 0.38).toFixed(2) + 'px');
      });

      ticking = false;
    }

    function requestParallax() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    updateParallax();
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax);

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(function () {
        root.classList.remove('promo-motion-enabled');
        root.classList.add('promo-motion-enabled');
      }, 0);
    });
  });
})();
